import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import ShadowCard from 'components/common/cards/ShadowCard';
import TextInputForm from 'components/common/forms/TextInputForm';
import BlueSwitchCheckboxInput from 'components/common/inputs/BlueSwitchCheckboxInput';
import { useForm } from 'contexts/FormContext';
import { parseIsoFromMarket, parseServiceObjectAutoComplete } from 'helpers/so';
import { useServiceObjects } from 'hooks/useServiceObjects';

export default function EuFormShippingAddressSection({ data }) {
  // Context
  const { form, market, inputOnChange, overwriteAddress, validateForm } =
    useForm();

  // Constants

  // inputNames need to match the order of models in inputModelArray.
  const inputNames = [
    'shipping-address-line-1',
    'shipping-address-line-2',
    'shipping-address-city',
    'shipping-address-postal',
    'shipping-address-state',
  ];

  // Get Service Object ISO.
  const iso = parseIsoFromMarket({ market });

  // Custom Hooks
  const { so } = useServiceObjects({
    inputNames,
    iso,
  });

  // Effects
  useEffect(() => {
    validateForm();
  }, [form.AddressIsTheSame]);

  useEffect(() => {
    if (!isEmpty(so)) {
      onFormAutoComplete({ so });
    }
  }, [so]);

  // Handles Service Object Auto Complete
  const onFormAutoComplete = ({ so }) => {
    // Parse auto complete return.
    const addressType = 'Ship';
    const address = parseServiceObjectAutoComplete({
      addressType,
      so,
    });

    // Overwrite form.
    overwriteAddress({ address });
  };

  // Contentful
  const {
    title,
    text1,
    text2,
    text3,
    reference1: {
      fields: { listArray: inputModelArray },
    },
  } = data.fields;

  return (
    <ShadowCard label={title}>
      <div className="form-max flex-20 column">
        <p className="address-country">
          {text1}
          <strong>{text2}</strong>
        </p>
        <TextInputForm
          form={form}
          validateForm={validateForm}
          inputs={inputModelArray}
          inputNames={inputNames}
          inputOnChange={inputOnChange}
        />
        <BlueSwitchCheckboxInput
          inputId="AddressIsTheSame"
          inputName="AddressIsTheSame"
          inputAriaLabel="AddressIsTheSame"
          inputChecked={form.AddressIsTheSame}
          inputOnChange={inputOnChange}
          label={text3}
        />
      </div>
    </ShadowCard>
  );
}
